import React from "react";

import { Table } from '@mantine/core';

import { utils } from "../../utils/globalVariables";
import { numberWithComma, getValuePropInObj } from "../../utils/globalFunctions";

import LabelContentInline from "../../components/general/LabelContentInline";

const DiscountMasterData = ({ stateData }) => {
    return (
        <React.Fragment>
            <LabelContentInline
                stateColLabel={4}
                stateLabel='Nama'
                stateContent={stateData.diskon_code_prefix}
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Voucher'
                stateContent={
                    stateData.diskon_type === utils.discountType.rupiah.value ? `Rp ${numberWithComma(Number(stateData.diskon_value))}` : `${Number(stateData.diskon_value)}%`
                }
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Dari'
                stateContent={getValuePropInObj(utils.discountDeductedFrom, 'value', stateData.diskon_deducted_from, 'label', ' - ')}
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Quota'
                stateContent={stateData.diskon_quota}
                stateDivider={true}
            />

            {Array.isArray(stateData.diskon_detil) && (stateData.diskon_detil.length > 0) &&

                <Table highlightOnHover withColumnBorders mt='xl'>
                    <thead>
                        <tr>
                            <th>No</th>
                            <th>Code</th>
                            <th>Status</th>
                        </tr>
                    </thead>

                    <tbody>
                        {Object.keys(stateData.diskon_detil).map((keyD, idxD) => {
                            return (
                                <tr key={idxD}>
                                    <td>{Number(idxD) + 1}</td>
                                    <td>{stateData.diskon_detil[keyD].diskon_code_sufix}</td>
                                    <td>{Number(stateData.diskon_detil[keyD].diskon_is_used) === 1 ? 'Used' : 'Available'}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </Table>
            }
        </React.Fragment>
    )
}

export default DiscountMasterData;